import { Box, IconButton, InputAdornment, TextField } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Dispatch, memo, SetStateAction, useState } from "react"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"


const ValueList = ({ addValue, handleName, name, setTouched, touched }: { touched: boolean; setTouched: Dispatch<SetStateAction<boolean>>; name: string | null, addValue: (newValue: string) => void, handleName: (newValue: string) => void }) => {
    const { t } = useTranslation()
    const styles = useStyles()

    const [value, setValue] = useState<string | null>(null)


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === "nameDropDownLists") {
            handleName(value);
            setTouched(true)
        }
        if (name === "valueDropDownList") {
            setValue(value);
        }
    };

    const showError = touched && (!name || name.trim().length < 3);

    return (

        <Box sx={styles.container}>
            <TextField
                name="nameDropDownLists"
                label={t('dropList.inputs.nameDropDownLists')}
                value={name}
                onChange={handleChange}
                //onBlur={() => handleName(localName)}
                placeholder={t('dropList.helperInputs.nameDropDownLists')}
                sx={styles.input(showError)}
                required
                error={showError}
                //helperText={showError ? t("dropList.inputs.errors.nameRequeried") : ""}
                helperText={
                    !touched
                        ? ""
                        : !name || name.trim().length === 0
                            ? t("dropList.inputs.errors.nameRequeried")
                            : name.trim().length < 3
                                ? t("dropList.inputs.errors.minLength", { min: 3 })
                                : ""
                }
                inputProps={{
                    maxLength: 255
                }}
            />

            <TextField
                name="valueDropDownList"
                label={t('dropList.inputs.valueDropDownList')}
                value={value}
                onChange={handleChange}
                placeholder={t('dropList.helperInputs.valueDropDownList')}
                sx={styles.input(false)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                className="add"
                                sx={styles.clean(!value || value.trim().length < 3)}
                                disabled={!value || value.trim().length < 3}
                                onClick={() => {
                                    if (value) {
                                        addValue(value)
                                        setValue('')
                                    }
                                }}
                            >
                                {icons('add')}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Box>

    )
}

export default memo(ValueList);
